import React, {useEffect, useRef, useState} from 'react';
import reactCSS from 'reactcss';

import LoadingComponent from '../loading/LoadingComponent.jsx';
import PlotSummary from './PlotSummary.js';

const TuvaLogo = "data:image/png;base64,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";

const styles = reactCSS({
    'default': {
        cover: {
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex: '1001',
            background: 'rgba(0, 0, 0, 0.85)'
        },
        body: {
            position: 'absolute',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex: '1002'
        },
        content: {
            margin: 'auto',
            maxWidth: '700px'
        }
    }
});

function Screenshot({getPlotPreview, close, Dyn, plotContainer, getSummary}) {

    const [pngDataUrl, setPngDataUrl] = useState();
    const [showCopied, setShowCopied] = useState(false);

    useEffect(() => {
        if(toolbar){
            setTimeout(() => {
                getPlotPreview((canvas) => {
                    // Add footer to canvas and convert canvas to data url
                    const canvasImage = document.createElement("canvas");
                    // adding footer with logo
                    const footerHeight = 70;
                    canvasImage.setAttribute('width',canvas.width);
                    canvasImage.setAttribute('height',canvas.height + footerHeight);
                    var context = canvasImage.getContext('2d');
                    context.drawImage(canvas,0,0,canvas.width, canvas.height);
                    var base_image = new Image();
                    base_image.src = TuvaLogo;
                    base_image.onload = () => {
                        const startX = 0,
                            startY = canvasImage.height - footerHeight,
                            barWidth = canvasImage.width,
                            // To draw tuva logo
                            logoXPos = barWidth - 150,
                            logoYPos = startY + 10;
                        // To fill the footer background
                        context.beginPath();
                        context.rect(startX, startY, barWidth, footerHeight);
                        context.fillStyle = '#fff';
                        context.fill();
                        context.closePath();
                        // Add tuva logo
                        context.drawImage(base_image, logoXPos, logoYPos, 80, 30);
                        setPngDataUrl(canvasImage.toDataURL("image/png"))
                    };
                });
            }, 300);
        }
    }, [toolbar]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                close();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listener on component unmount
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [close]);

    function copyToClibboard() {
        if(window.ClipboardItem) {
            navigator.clipboard.write([
                new window.ClipboardItem({
                    ['image/png']: new Promise(async (resolve) => {
                        const blob = await (await fetch(pngDataUrl)).blob();
                        resolve(blob);
                    })
                })
            ]).then(() => {
                setShowCopied(true);
                setTimeout(() => {
                    setShowCopied(false);
                }, 2000);
            }).catch(err => {
                console.log("error", err);
            });
        } else {
            console.log("Browser doesn't support copy image feature.");
        }
    }

    function downloadAsPng() {
        // To make the canvas download
        const link = document.createElement("a"),
            chartTitle = Dyn.plotView.topMargin.getTitle() + "-tuva.png";
        link.download = chartTitle;
        link.type = "hidden";
        link.href = pngDataUrl;
        document.body.appendChild(link);	// required for firefox
        link.click();
        document.body.removeChild(link);
    }

    // To save the active plot area as SVG
    function getPlotAsSVGImage() {
        Dyn.plotView.makePlotImageReady( true );

        //get svg element.
        var svg = $(plotContainer).find('svg')[0],
        serializer = new XMLSerializer(), //get svg source.
        source = serializer.serializeToString(svg),
        chartTitle = Dyn.plotView.topMargin.getTitle() + "_tuvalabs.svg";
        //add name spaces.
        if(!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
            source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if(!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
            source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }

        //add xml declaration
        source = '<?xml version="1.0" standalone="no"?>\r\n' + source;
        Dyn.plotView.makePlotImageReady( false );

        return source;
    }

    function downloadAsSVG() {
        // To make the canvas download
        const link = document.createElement("a"),
            chartTitle = Dyn.plotView.topMargin.getTitle() + "-tuva.svg";
        link.download = chartTitle;
        link.type = "hidden";
        link.href = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(getPlotAsSVGImage());
        document.body.appendChild(link);	// required for firefox
        link.click();
        document.body.removeChild(link);
    }

    const showLoading = !pngDataUrl;
    // Hide copy button when a browser doesn't support Clipbord blob copy
    const hideCopy = !window.ClipboardItem;
    const isPlotView = !!Dyn.plotView;

    return <>
    <div style={styles.cover} onClick={close} aria-label={Dyn.loc('Close')} className="tde-p-6 tde-screenshot-view">
        <button
            className='tde-float-right tde-i tde-i-close tde-cursor-pointer'
            onClick={(e) => {
                e.stopPropagation();
                close();
            }}
            autoFocus
            style={{color: '#ffffff', background: 'transparent', border: 'none', position: 'relative', top: '-10px'}}
        ></button>
        <div style={styles.content} className="tde-bg-color tde-d-flex tde-fill tde-flex-direction-col"
            onClick={(e)=> {
                e.preventDefault();
                e.stopPropagation();
            }}>
            <div aria-labelledby="dialogTitleScreenshot" className='tde-d-flex tde-flex-items-center tde-mx-4' style={{justifyContent: "space-between"}}>
                <h3 id="dialogTitleScreenshot" className='tde-h3 tde-my-3'>{Dyn.loc( 'Screenshot' )}</h3>
                <div>
                    {!hideCopy && (
                    <button disabled={showLoading} className={'tde-btn tde-mr-3' + (showCopied? ' tde-active': '')} onClick={copyToClibboard}>
                        <i className='tde-i tde-i-copy'></i> {Dyn.loc( showCopied? 'Copied': 'Copy' )}
                    </button>
                    )}
                    <button disabled={showLoading} className='tde-btn tde-mr-3' onClick={downloadAsPng}>
                        <i className='tde-i tde-i-download'></i> {Dyn.loc( 'Download PNG' )}
                    </button>
                    {isPlotView &&
                    <button disabled={showLoading} className='tde-btn' onClick={downloadAsSVG}>
                        <i className='tde-i tde-i-download'></i> {Dyn.loc( 'Download SVG' )}
                    </button>
                    }
                </div>
            </div>
            <div className='tde-border-top tde-d-flex tde-flex-1 tde-flex-items-center tde-p-4' style={{overflow: "auto"}}>
                <div className='tde-flex-1 tde-text-center'>
                    {pngDataUrl && <img src={pngDataUrl} style={{maxWidth: '100%'}}/> }
                    {showLoading && <LoadingComponent label={Dyn.loc( 'Capturing the plot...' )} />}
                </div>

            </div>
            <PlotSummary getSummary={getSummary} pngDataUrl={pngDataUrl} Dyn={Dyn} />
        </div>
    </div>
    </>
}

export default Screenshot;
